import { reflect } from '@effector/reflect'

import { modalOpener } from '@/shared/ui/modal'

import * as model from './model'
import { PasswordForgotDialog as View } from './view'

export const PasswordForgotDialog = {
    View: reflect({
        view: View,
        bind: {
            onClick: model.buttonClicked,
            nonInteractive: model.$interactionDisabled,
        },
    }),
    model,
}

model.showFx.use(modalOpener(PasswordForgotDialog.View))
